import React from 'react';

import useStyles from './styles';

interface Props {
    primary?: React.ReactNode;
    secondary?: React.ReactNode;
    className?: string;
}

const Paragraph: React.FC<Props> = ({ primary, secondary, className }) => {
    const { classes, cx } = useStyles();

    return (
        <div className={cx(classes.root, className)}>
            {primary ? <span className={classes.primary}>{primary}</span> : null}
            {secondary ? <span className={classes.secondary}>{secondary}</span> : null}
        </div>
    );
};

export default Paragraph;
